/*
vertical-menu.directive.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('modules/shell/widgets/vertical-menu/vertical-menu.directive',[
    'lodash',
    'jquery',
    'angular',
    'angularTranslate'
], function (_, $, angular) {
    'use strict';

    var module = angular.module('GEVerticalMenu', ['pascalprecht.translate']);

    module.service('RecursionHelper', ['$compile', function ($compile) {
        /**
         * Manually compiles the element, fixing the recursion loop.
         * @param element
         * @param [link] A post-link function, or an object with function(s) registered via pre and post properties.
         * @returns An object containing the linking functions.
         */
        this.compile = function (element, link) {
            // Normalize the link parameter
            if (angular.isFunction(link)) {
                link = { post: link };
            }

            // Break the recursion loop by removing the contents
            var contents = element.contents().remove();
            var compiledContents;
            return {
                pre: (link && link.pre) ? link.pre : null,
                /**
                 * Compiles and re-adds the contents
                 */
                post: function (scope, element) {
                    // Compile the contents
                    if (!compiledContents) {
                        compiledContents = $compile(contents, scope);
                    }
                    // Re-add the compiled contents to the element
                    compiledContents(scope, function (clone) {
                        element.append(clone);
                    });

                    // Call the post-linking function, if any
                    if (link && link.post) {
                        link.post.apply(null, arguments);
                    }
                }
            };
        };
    }]);

    var MenuItem = {
        getActiveItem: function () {
            return (this.menuItems || []).filter(function (item) { return item.active; })[0];
        },
        unactivateItems: function (activeItem, recursive) {
            _.forEach(this.menuItems, function (item) {
                item.active = item === activeItem;

                if (item.navigate !== undefined && !item.navigate && !item.active) {
                    item.collapsed = true;
                }
                item.open = false;

                if (recursive) {
                    var aItem = MenuItem.getActiveItem.call(item);
                    MenuItem.unactivateItems.call(item, item.active && aItem, recursive);
                }
            });
        },
        menuLink: function ($scope) {
            $scope.menuItems = $scope.menuItems || [];
            $scope.level = parseInt($scope.level, 10) || 0;

            $scope.onClick = function (item, source) {
                var open = !!item.open;
                MenuItem.unactivateItems.call($scope, item);
                item.open = source ? true : !open;
                $scope.onItemClick({ item: item, source: source || item });
            };

            MenuItem.unactivateItems.call($scope, MenuItem.getActiveItem.call($scope));
        }
    };

    /**
     * geVerticalMenu directive
     *
     * Implements a vertical menu with multiple levels
     *
     * @param menuItems         Required. Array of MenuItems items
     * @param activatedMenuItem Optional. Indicates the current selected first level item
     * @param onMenuItemClick   Optional. Callable expression to be executed when a MenuItem is selected
     */
    module.directive('geVerticalMenu', ['$window', function ($window) {
        return {
            restrict: 'E',
            templateUrl: 'modules/shell/widgets/vertical-menu/vertical-menu.directive.html',
            scope: {
                menuItems: '=',
                isCollapsed: '=',
                selectedMenuItem: '=?',
                onItemClick: '&?',
                onOutsideClick: '&?',
                onWindowSizeChange: '&?'
            },
            link: function ($scope, $element) {

                var breakpoints = [992, 1366];
                var sizes = ['XS', 'SM', 'MD'];
                $scope.size = '';

                var clickHandler = function (event) {
                    var isClickedElementAChild = $element.find(event.target).length > 0;

                    if (!isClickedElementAChild) {
                        $scope.onOutsideClick && $scope.onOutsideClick();
                        $scope.$apply();
                    }
                };

                var resizeHandler = function () {
                    $scope.size = '';
                    for (var i = 0; i < breakpoints.length && !$scope.size; i++) {
                        if ($window.innerWidth < breakpoints[i]) {
                            $scope.size = sizes[i];
                        }
                    }

                    $scope.size = $scope.size || sizes[breakpoints.length];

                    $scope.onWindowSizeChange && $scope.onWindowSizeChange({ size: $scope.size });
                };

                $window.document.addEventListener('click', clickHandler);
                $window.addEventListener('resize', resizeHandler);

                $scope.$on('$destroy', function () {
                    $window.document.removeEventListener('click', clickHandler);
                    $window.removeEventListener('resize', resizeHandler);
                });

                $scope.$watch('selectedMenuItem', function (newValue) {
                    if (newValue) {
                        MenuItem.unactivateItems.call($scope, MenuItem.getActiveItem.call($scope), true);
                    }
                });

                MenuItem.menuLink($scope);
                resizeHandler();
            }
        };
    }]);

    module.directive('geMenuItem', ['RecursionHelper', function (recursionHelper) {
        return {
            restrict: 'E',
            templateUrl: 'modules/shell/widgets/vertical-menu/menu-item.directive.html',
            scope: {
                label: '=',
                id: '=?',
                icon: '=?',
                active: '=?',
                collapsed: '=?',
                open: '=?',
                level: '=?',
                menuItems: '=?',
                onItemClick: '&'
            },
            compile: function (element) {
                return recursionHelper.compile(element, MenuItem.menuLink);
            }
        };
    }]);

    return module;
});
